import { useRecoilValue } from "recoil";
import { useTempDocumentsQuery } from "../queries/useTempDocumentsQuery";
import { useEffect, useState } from "react";
import { isFormReselectedState } from "store/document/documentCommon";

const useTempDocModal = ({ categoryUuid }: { categoryUuid: string }) => {
  const { data: tempDocuments } = useTempDocumentsQuery({
    categoryUuid,
  });
  const [openTempSaveDocsModal, setOpenTempSaveDocsModal] = useState(false);

  const isFormReselected = useRecoilValue(isFormReselectedState);

  useEffect(() => {
    if (isFormReselected) return;

    if (tempDocuments && tempDocuments.length > 0) {
      setOpenTempSaveDocsModal(true);
    }
  }, [tempDocuments, isFormReselected]);

  return {
    openTempSaveDocsModal,
    setOpenTempSaveDocsModal,
  };
};

export default useTempDocModal;
